import { NgForm } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PrestamoAbonoService } from 'src/app/services/prestamo-abono/prestamo-abono.service'
import { MatDialog } from '@angular/material/dialog';
import { DialogEditPrestamoEjecutivo } from 'src/app/components/prestamos/prestamos-confirmar.component';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { Usuario } from 'src/app/models/usuario/usuario.model';
import { TiposService } from 'src/app/services/tipos/tipos.service';
import { DialogPagoPrestamo } from './prestamo-pago.component';
import { DialogAnularPrestamo } from '../prestamos/prestamos-anular.component';
import { AppComponent } from 'src/app/app.component';
import Swal from 'sweetalert2';



declare const Rut: any;
@Component({
  selector: 'app-prestamos-jub',
  templateUrl: '../../pages/prestamo-abono/prestamo-abono.html',
  styleUrls: ['../../pages/prestamo-abono/prestamo-abono.component.css']
})
export class PrestamoAbonoJubComponent implements OnInit {
  tipos: any
  cuotas: any
  totalMaximo: any
  prestamos: any
  planes: any
  user: any
  rol: string = localStorage.getItem("rol")
  config: any = { itemsPerPage: 5, currentPage: 1, totalItems: 5, indexInicial: 0, indexMaximo: 5 }
  configPlan: any = { itemsPerPage: 10, currentPage: 1, totalItems: 10, indexInicial: 0, indexMaximo: 10 }
  tipoPostulacion: string = "Pagadas"
  allComplete: boolean = false
  prestamoSolicitado: any
  idEjecutivo = localStorage.getItem("idUsuario")
  nombreUsuario: any
  rutUsuario: any

  selectPrestamo: any = { value: "0" }
  deshabilitado: true
  afiliado: any = { rutAfiliado: '', idAfiliado: '', nombreAfiliado: '', apellidoAfiliado: '' };
  buscador: any =
    {
      selectPrestamo: 0,
      rut: '', rut2: '', rutAfiliado: '', region: '', fechaInicio: '', fechaFin: '', itemsPerPage: 5, currentPage: 1, idSolicitud: '',
      estado: ['PAGADA']
    }

  constructor(public router: Router, public prestamoAbonoService: PrestamoAbonoService,
    private dialog: MatDialog,
    private appComponent: AppComponent,
    private tiposService: TiposService) { }

  ngOnInit(): void { this.loadData() }

  loadData() {
    let vm = this
    if(localStorage.getItem("jubilado")!='true' && !localStorage.getItem("rol"))
    {
        this.appComponent.logoutJubilado();
    }
    if (this.rol == 'ROLE_AFILIADO') {

      this.nombreUsuario = localStorage.getItem("nombreUsuario");
      this.rutUsuario = localStorage.getItem("rutUsuario") + "-" + localStorage.getItem("dvUsuario");
      if (this.rol == 'ROLE_AFILIADO') {
        this.afiliado.nombreAfiliado = this.nombreUsuario;
        this.afiliado.rutAfiliado = this.rutUsuario;
        this.afiliado.idAfiliado = this.idEjecutivo;

      }

      this.prestamoAbonoService.traePrestamosPagados(this.idEjecutivo, this.buscador).then(
        (prestamosPagados: any) => {
          vm.prestamos = prestamosPagados.resultado
          vm.buscador.paginasTotal = prestamosPagados.resultado.length
          vm.config.currentPage = this.buscador.currentPage
          vm.config.totalItems = prestamosPagados.cantidadRegistros
          Swal.close();


        }

      ).catch(error => console.log(error))

    } else { console.log("debe ingresar el rut!!!"); }

  }

  buscarListaPrestamos(idUsuario: any) {
    let vm = this
    this.prestamoAbonoService.traePrestamosPagados(idUsuario, this.buscador).then(
      (prestamosPagados: any) => {
        vm.prestamos = prestamosPagados.resultado
        vm.buscador.paginasTotal = prestamosPagados.resultado.length
        vm.config.currentPage = this.buscador.currentPage
        vm.config.totalItems = prestamosPagados.cantidadRegistros
        //vm.verPlanPago(0)
        Swal.close();
      }

    ).catch(error => console.log(error))
    // this.reloadComponent();
  }


  anularPrestamo(idPostulacion: any, idUsuario: any) {
    let vm = this;
    let data: any = {
      idPostulacion: idPostulacion,
      asientoContable: ''
    }
    const dialogRef = this.dialog.open(DialogAnularPrestamo,
      { disableClose: true, width: '40%', data: data })

    dialogRef.afterClosed().subscribe(() => {
      this.buscarListaPrestamos(idUsuario);
      if (data.recarga) vm.loadData();
    });
  }
  verPlanPago(idPrestamo: any) {
    this.prestamoAbonoService.traePlanPago(idPrestamo).then(
      planes => {
        this.planes = planes
      }
    ).catch(error => 
      console.log(error)
    )

  }
  pagarDeuda(id: any, numCuota: any, mostrarPago: any, posicion: any, estadoPrevio: any) {
    let vm = this;
    
    if (posicion > 0 && mostrarPago && estadoPrevio == 'VIGENTE') {
      this.openAlertDialog('Se debe pagar antes la cuota pendiente', 'btn-danger');
      Swal.close();
      return false;
    }
    this.prestamoAbonoService.traePlanAPagarPrestamo(id, numCuota).then(
      (response: any) => {
        let data: any =
        {
          mostrarPago: mostrarPago,
          idPrestamo: response.idPrestamo,
          idPostulacion: response.idPostulacion,
          nombreUsuario: response.nombreUsuario,
          apellidoUsuario: response.setApPaternoUsuario,
          tasaInteres: response.tasaInteres,
          valorCuota: response.valorCuota,
          rutUsuario: response.rutUsuario,
          cantidadCuota: response.cantidadCuota,
          idCantidadCuota: response.idCantidadCuota,
          totalCuota: response.totalCuota,
          montoCuota: response.totalCuota - response.tasaInteres,
          fechaIngreso: response.fechaIngreso,
          fechaPrimerPago: response.fechaPrimerPago,
          montoSolicitado: response.montoSolicitado,
          montoTotalCuota: response.montoTotalCuota,
          tipoPrestamo: response.tipoPrestamo,
          numCuota: numCuota,
          idPlanPago: response.idPlanPago,
          estado:response.estado
        }

        const dialogRef = vm.dialog.open(DialogPagoPrestamo,
          { width: '40%', data: data, disableClose: true })
        Swal.close();
        dialogRef.afterClosed().subscribe(() => {
          if (mostrarPago == true) {
            //  this.reloadComponent();
          
            this.verPlanPago(response.idPrestamo);

          }
        })
      }
    )
      .catch(error => {
        console.log(error)
        Swal.close();
       /* if((error.error.message) && (error.error.message="Token expirado")){
          vm.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
          this.appComponent.logoutJubilado();
        }else{*/
          this.openAlertDialog('No se pudo obtener la cuota a pagar.', 'btn-dark')
       // } 
      })
  }


  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }
  buscaAfiliado(rutABuscar: any) {

    if (Rut(rutABuscar)) {
      let rut = rutABuscar.split('.').join('').split('-')[0]

      this.traePostulantes(rut);
      console.log("this.afiliado.idAfiliado ", this.afiliado.idAfiliado);


    }
    else { this.openAlertDialog('El RUT es incorrecto. Favor Revisar', 'btn-danger') }
  }



  traePostulantes(rut: any) {
  
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();
    let vm = this
    this.prestamoAbonoService.traePostulantes(rut).then
      (
        (usuario: Usuario) => {

          vm.afiliado.nombreAfiliado = usuario.nombres + ' ' + usuario.apellidoPaterno
          vm.afiliado.rutAfiliado = usuario.rut + "-" + usuario.dv
          vm.afiliado.idAfiliado = usuario.id
          console.log("idAfiliado", vm.afiliado.idAfiliado)
          this.buscarListaPrestamos(this.afiliado.idAfiliado);

          Swal.close();

        }
      )
      .catch(error => {
        Swal.close();
        /*if((error.error.message) && (error.error.message="Token expirado")){
          vm.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
          this.appComponent.logoutJubilado();
        }else{*/
          vm.openAlertDialog('No se han encontrado usuarios con el RUT ingresado. Intente nuevamente.', 'btn-danger')
       // } 
      })
  }
  openAlertDialog(mensaje: string, clase: string) {
    this.dialog.open(AlertDialogComponent, {
      data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
    })
  }



  salir() { this.router.navigate(['/index']) }

  pageChanged(event: any,rutABuscar:any) {  
    this.config.currentPage = event 
    this.buscador.currentPage = event
    this.config.indexInicial = ( (this.config.currentPage - 1) * this.config.itemsPerPage)
    this.config.indexMaximo = ( this.config.currentPage * this.config.itemsPerPage )
    let rut = rutABuscar.split('.').join('').split('-')[0]
    this.planes = []
    if(rut){
      this.traePostulantes(rut);  
    }      
  }


  openEditDialog(idPostulacion: any, nombreProducto: any, mostrarEditar?: any, disponiblePago?: any): void {
    this.openDialogPrestamo(idPostulacion, mostrarEditar, disponiblePago);


  }
  openDialogPrestamo(idPostulacion: any, mostrarEditar?: any, disponiblePago?: any) {
    let vm = this

    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();
    let mostrarAprobarButton = true;
    let mostrarEnviarButton = true;
    if (disponiblePago) {
      mostrarAprobarButton = false;
      mostrarEnviarButton = false;

      if (localStorage.getItem("rol") == 'ROLE_ADMINISTRADOR') {
        disponiblePago = false;
        mostrarAprobarButton = true;
        mostrarEnviarButton = true;
      }

    }
    this.prestamoAbonoService.traeTipoPrestamo().then(tipo => this.tipos = tipo).catch(error => console.log(error))

    this.prestamoAbonoService.traeCantidadCuotas().then(cuota => this.cuotas = cuota).catch(error => console.log(error))

    this.prestamoAbonoService.traeMontoTotalDisponible(this.idEjecutivo).then(response => {
      this.totalMaximo = response;
    }
    ).catch(error => {
      console.log(error);
      this.totalMaximo = 0;
    });
    this.prestamoAbonoService.traePrestamo(idPostulacion, mostrarEditar).then
      (

        (response: any) => {

          let data: any =
          {
            archivos: response.archivoAdjunto,
            tipos: this.tipos,
            cuotas: this.cuotas,
            totalMaximo: this.totalMaximo,
            idPrestamo: response.idPrestamo,
            idPostulacion: response.idPostulacion,
            nombreUsuario: response.nombreUsuario,
            apellidoUsuario: response.apellidoUsuario,
            idCodeudor1: response.idCodeudorUno,
            idCodeudor2: response.idCodeudorDos,
            rutCodeudor1: response.rutCodeudorUno,
            rutCodeudor2: response.rutCodeudorDos,
            nombreCodeudor1: response.nombreCodeudorUno,
            nombreCodeudor2: response.nombreCodeudorDos,
            apellidoCodeudor1: response.apellidoCodeudorUno,
            apellidoCodeudor2: response.apellidoCodeudorDos,
            rutUsuario: response.rutUsuario,
            cantidadCuotas: response.cantidadCuota,
            montoCuota: response.totalCuota,
            fechaIngreso: response.fechaIngreso,
            fechaPrimerPago: response.fechaPrimerPago,
            montoSolicitado: response.montoSolicitado,
            tipoPrestamo: response.tipoPrestamo,
            deshabilitado: true,
            presionaEditar: false,
            idCantidadCuotas: response.idCantidadCuotas,
            idUsuario: response.idUsuario,

            mostrarEditar: mostrarEditar,
            disponiblePago: !disponiblePago,
            mostrarAprobarButton: mostrarAprobarButton
          }

          let vm = this

          const dialogRef = vm.dialog.open(DialogEditPrestamoEjecutivo, {
            width: '45%', disableClose: true, data: data
          })
          Swal.close();

          dialogRef.afterClosed().subscribe(() => { })
        }
      )
      .catch(error => {
        Swal.close();
       /* if((error.error.message) && (error.error.message="Token expirado")){
          vm.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
          this.appComponent.logoutJubilado();
        }*/
      })
  }

}



